import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(partnerId, queue) {
  return yield oncallFetch("/api/oncall/administration/partners/queues/add", {
    partnerId,
    queue,
  });
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/administration/partners/queues/add.js